import "./index.css";

import logo from "./enspire_logo3_white_bg.gif";

export function App() {
  return (
    <div>
      <div className="flex flex-row header items-center">
        <div className="basis-1/2 shrink-0 md:basis-1/4">
          <img
            src={logo}
            alt="Enspire Digital Logo"
          />
        </div>
        <div className="basis-1/2 shrink-0 md:basis-3/4"></div>
      </div>
      <div className="homepage-hero-container">
        <div className="homepage-hero-text">
          <h1>
            The team at Enspire Digital would like to
            wish you a Merry Christmas 🎅 and a wonderful
            new year 🎉
          </h1>
        </div>
      </div>
      <div className="main-content">
        <h1 className="text-2xl">
          Enspire Digital will be closed from the 22nd December 2025 and reopen on the 12th January 2026. <br />
          We will be back with a brand new website and a new look!
        </h1>
        <div className="mt-8">
          For any enquiries, please contact us at <a href="mailto:sales@enspiredigital.com.au">sales@enspiredigital.com.au</a>
        </div>
      </div>
      <div className="footer-container">
        <div className="footer-row">
          <div className="footer-copyright">
            Copyright © {new Date().getFullYear()} Excelera Pty Ltd. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
